module.exports = __webpack_public_path__ + "ml.9188dccfffec289aa463.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ml.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ml.svg
// module chunks = styles